export default __webpack_public_path__ + "contentmodules/announce_survey_sharing_popup.81914bc5.png";